import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'selector',
})
export class SelectorPipe implements PipeTransform {
  transform(value: string, ...args: unknown[]): unknown {
    return value.replace(/\s/g, '-').toLowerCase();
  }
}
